import {
  DEFAULT_NAMED_GRAPH_IRI,
  LOCAL_NAMED_GRAPH_IRI,
} from 'src/templates/queries/iris';

export const getDefaultModelNamedGraphs = (reasoningSchemaGraphs: string[]) =>
  reasoningSchemaGraphs.map((namedGraph) => {
    switch (namedGraph) {
      case '*':
        return LOCAL_NAMED_GRAPH_IRI;
      case 'default':
        return DEFAULT_NAMED_GRAPH_IRI;
      default:
        return namedGraph;
    }
  });
